import { render, staticRenderFns } from "./ArtworkWidget.vue?vue&type=template&id=56366aa2&scoped=true"
import script from "./ArtworkWidget.vue?vue&type=script&lang=js"
export * from "./ArtworkWidget.vue?vue&type=script&lang=js"
import style0 from "./ArtworkWidget.vue?vue&type=style&index=0&id=56366aa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56366aa2",
  null
  
)

export default component.exports